import { INVALID_NAME_MESSAGE } from '../constants/validation';
import { AuthError } from '../enums/errors/auth-error.enum';
import { RecaptchaError } from '../enums/errors/recaptcha-error.enum';

export const ACCOUNT_NOT_FOUND = 'auth.accountNotFound';
export const UNAUTHORIZED = 'Unauthorized';

export const ACCOUNT_NOT_CONFIRMED = 'auth.accountNotConfirmed';
export const DIRECT_ACCESS_EXPIRED = 'auth.directAccessExpired';
export const SAME_RESET_PASSWORD_ERROR = 'same_reset_password_error';

export const INVALID_PHONE_NUMBER = 'invalid_phone_number';
export const LANDLINE_DETECTED = 'landline_detected';

// raw error messages thrown by SmsService.validate() - shared so the frontend can match them via includes()
export const LANDLINE_ERROR = 'landline detected - not sending message.';
export const DISALLOWED_PHONE_TYPE_ERROR = 'phone number type is not allowed';
export const INVALID_EMAIL_ADDRESS_MX = 'invalid_email_mx';
export const INVALID_EMAIL_ADDRESS_PLUS = 'invalid_email_plus';
export const INVALID_EMAIL_ADDRESS_IN_USE = 'email_already_exists';
export const INVALID_PHONE_NUMBER_COUNTRY = 'invalid_phone_number_country';
export const INVALID_EMAIL_MUST_BE_AN_EMAIL = 'email must be an email';
export const PHONE_NUMBER_ALREADY_CONFIRMED = 'phone_number_already_confirmed';
export const PHONE_NUMBER_CHANGE_LIMIT_EXCEEDED = 'phone_number_change_limit_exceeded';

export const EXPECTED_REGISTRATION_ERRORS = [
  INVALID_NAME_MESSAGE,
  INVALID_PHONE_NUMBER,
  INVALID_EMAIL_ADDRESS_MX,
  INVALID_EMAIL_ADDRESS_PLUS,
  INVALID_EMAIL_ADDRESS_IN_USE,
  INVALID_EMAIL_MUST_BE_AN_EMAIL,
  RecaptchaError.InvalidRecaptchaV3,
  ...Object.values(AuthError),
];
